import { gateway } from "../../gateway";

export const getSelfCompaniesAction = async () => {
    const res = await gateway.get("/companies/self");
    return res?.data || res?.data?.data;
};